
import React from "react";
import "./AddOnExperiences.css";
import { Link } from "react-router-dom";

const experiences = [
  {
    number: "01",
    icon: "🎬",
    title: "Pre-Decorated Private Theatre",
    subtitle: "A celebration, already dressed up",
    description:
      "Walk into a private theatre beautifully prepared for your special moment. Enjoy our signature fixed décor, ambient lighting, and an intimate celebration atmosphere.",
    features: ["Included with your experience", "Signature fixed décor"],
    className: "theatre",
  },
  {
    number: "02",
    icon: "🎂",
    title: "Celebration Cakes",
    subtitle: "Make every moment sweeter",
    description:
      "Add a delicious cake to your private celebration. Whether it is a birthday, anniversary, or a surprise for someone special, make the occasion even more memorable.",
    features: ["Birthday celebrations", "Anniversary surprises"],
    className: "cake",
  },
  {
    number: "03",
    icon: "🍿",
    title: "Food & Beverages",
    subtitle: "Your favourite treats, your way",
    description:
      "Make movie time more enjoyable with tasty snacks, refreshing beverages, and delightful food options. Turn your private screening into a complete leisure experience.",
    features: ["Snacks & refreshments", "Food add-on options"],
    className: "food",
  },
  {
    number: "04",
    icon: "💐",
    title: "Bouquets & Gifts",
    subtitle: "Say it with something special",
    description:
      "Surprise someone you love with a beautiful bouquet or a thoughtful gift. Add a personal touch to birthdays, romantic dates, anniversaries, and special milestones.",
    features: ["Flowers & bouquets", "Thoughtful gifting"],
    className: "gifts",
  },
  {
    number: "05",
    icon: "🌫️",
    title: "Fog Entry",
    subtitle: "Make your entrance unforgettable",
    description:
      "Create a dramatic entrance with a striking fog effect. Add a cinematic touch to your celebration and make your special arrival feel like a scene from a movie.",
    features: ["Dramatic entrance", "Cinematic atmosphere"],
    className: "fog",
  },
  {
    number: "06",
    icon: "🎨",
    title: "Canvas Painting",
    subtitle: "Create a memory together",
    description:
      "Unleash your creativity with a fun canvas painting experience. Share colours, laughter, and quality time while creating a personal keepsake to remember your day.",
    features: ["Creative activity", "A memorable keepsake"],
    className: "painting",
  },
  {
    number: "07",
    icon: "🎵",
    title: "Customized Song",
    subtitle: "Your feelings, in a melody",
    description:
      "Make your celebration more personal with a customized song experience. Dedicate a meaningful melody to your favourite person and create a moment worth remembering.",
    features: ["Personal dedication", "Special musical moments"],
    className: "song",
  },
  {
    number: "08",
    icon: "🎤",
    title: "Karaoke",
    subtitle: "Take the spotlight",
    description:
      "Grab the microphone, sing your favourite songs, and let the fun begin. Enjoy a lively karaoke session with your partner, friends, or family in your own private space.",
    features: ["Sing your favourites", "Fun with your group"],
    className: "karaoke",
  },
];

function AddOnExperiences() {
  return (
    <main className="hex-addon-page">
      <section className="hex-addon-hero">
        <div className="hex-addon-hero-glow hex-addon-glow-one" />
        <div className="hex-addon-hero-glow hex-addon-glow-two" />

        <div className="hex-addon-container">
          <div className="hex-addon-eyebrow">
            <span className="hex-addon-eyebrow-dot" />
            THE HEXAPLAY EXPERIENCE
          </div>

          <h1>
            Make It More
            <span> Than a Movie.</span>
          </h1>

          <p className="hex-addon-hero-description">
            Little surprises. Big feelings. Unforgettable moments.
            Elevate your private theatre experience with thoughtfully
            curated add-ons made for celebrating your way.
          </p>

          <a href="#hex-addon-collection" className="hex-addon-hero-button">
            Explore Experiences
            <span aria-hidden="true">↘</span>
          </a>

          <div className="hex-addon-hero-note">
            <span>✦</span> Your moment, your way
            <span className="hex-addon-note-divider">/</span>
            Made for memories
          </div>
        </div>

        <div className="hex-addon-hero-orbit hex-addon-orbit-one" />
        <div className="hex-addon-hero-orbit hex-addon-orbit-two" />
      </section>

      <section
        className="hex-addon-collection"
        id="hex-addon-collection"
      >
        <div className="hex-addon-container">
          <div className="hex-addon-section-heading">
            <div>
              <span className="hex-addon-section-kicker">
                CURATED FOR YOUR MOMENT
              </span>
              <h2>
                The Extras That Make
                <span> It Extraordinary.</span>
              </h2>
            </div>

            <p>
              From sweet surprises to cinematic entrances, discover
              the little details that turn an ordinary outing into
              your own extraordinary story.
            </p>
          </div>

          <div className="hex-addon-grid">
            {experiences.map((experience) => (
              <article
                className={`hex-addon-card hex-addon-card-${experience.className}`}
                key={experience.number}
              >
                <div className="hex-addon-card-top">
                  <span className="hex-addon-number">
                    {experience.number}
                  </span>
                  <span className="hex-addon-card-mark">✳</span>
                </div>

                <div
                  className="hex-addon-icon-stage"
                  aria-hidden="true"
                >
                  <div className="hex-addon-icon-shadow" />
                  <div className="hex-addon-icon">
                    {experience.icon}
                  </div>
                  <div className="hex-addon-icon-sparkle">
                    ✦
                  </div>
                </div>

                <div className="hex-addon-card-content">
                  <span className="hex-addon-card-subtitle">
                    {experience.subtitle}
                  </span>

                  <h3>{experience.title}</h3>

                  <p>{experience.description}</p>

                  <div className="hex-addon-features">
                    {experience.features.map((feature) => (
                      <span key={feature}>
                        <span className="hex-addon-feature-check">
                          ✓
                        </span>
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="hex-addon-card-bottom">
                  <span className="hex-addon-bottom-line" />
                  <span className="hex-addon-bottom-star">✦</span>
                </div>
              </article>
            ))}
          </div>

          <div className="hex-addon-note">
            <span className="hex-addon-note-icon">✦</span>
            <p>
              <strong>A little note:</strong> Pre-decorated theatre
              décor is included with the experience. Other add-ons
              may be available at an additional charge and are
              subject to availability.
            </p>
          </div>
        </div>
      </section>

      <section className="hex-addon-cta">
        <div className="hex-addon-cta-inner">
          <span className="hex-addon-section-kicker">
            YOUR STORY STARTS HERE
          </span>
          <h2>
            Ready to Make
            <span> It Unforgettable?</span>
          </h2>
          <p>
            Choose your experience, bring your favourite people,
            and let HexaPlay take care of the atmosphere.
          </p>

          <Link to="/" className="hex-addon-cta-button">
            Plan Your Experience
            <span aria-hidden="true">↗</span>
          </Link>
        </div>
      </section>
    </main>
  );
}

export default AddOnExperiences;
